import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../utils/api';
import { Card, Tag } from '../components/ui';

export default function ArticleSinglePage() {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    api.get(`/articles/${id}`).then(r => { setArticle(r.data.article); setRelated(r.data.related); }).catch(() => {});
  }, [id]);

  if (!article) return <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 80 }}>Loading...</div>;

  return (
    <div>
      <div style={{ padding: '120px 40px 20px', textAlign: 'center', background: 'linear-gradient(160deg,var(--cream),var(--soft-orange))' }}>
        <Tag type={article.category} style={{ marginBottom: 12 }}>{article.category}</Tag>
        <h1 className="serif" style={{ fontSize: 'clamp(2rem,4vw,3rem)', maxWidth: 700, margin: '12px auto' }}>{article.title}</h1>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', alignItems: 'center', fontSize: 14, color: 'var(--brown)', marginTop: 12 }}>
          <span>By <strong>{article.author_name}</strong></span><span>·</span><span>{article.read_time}</span>
          <span>·</span><span>{article.published_at ? new Date(article.published_at).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }) : ''}</span>
        </div>
      </div>
      <section style={{ padding: '40px 40px 80px', maxWidth: 750, margin: '0 auto' }}>
        <Card style={{ padding: 40 }}>
          <div style={{ fontSize: 16, lineHeight: 1.9, color: 'var(--dark)' }}>
            {article.content.split('\n\n').map((p, i) => <p key={i} style={{ marginTop: i ? 20 : 0 }}>{p}</p>)}
          </div>
        </Card>
        {related.length > 0 && (
          <div style={{ marginTop: 60 }}>
            <h3 className="serif" style={{ fontSize: '1.5rem', marginBottom: 20 }}>Related Articles</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(220px,1fr))', gap: 20 }}>
              {related.map(r => (
                <Link key={r.id} to={`/articles/${r.id}`}><Card style={{ padding: 20, display: 'flex', flexDirection: 'column', gap: 8 }}>
                  <Tag type={r.category}>{r.category}</Tag>
                  <h4 className="serif" style={{ fontSize: '1.1rem' }}>{r.title}</h4>
                  <p style={{ fontSize: 13, color: '#999' }}>{r.author_name} · {r.read_time}</p>
                </Card></Link>
              ))}
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
